import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { startGoogleLogin } from "@/lib/api";
import { assetUrl } from "@/components/Brand";

const $ = (sel) => document.getElementById("static-shell")?.querySelectorAll(sel) || [];

// Drives the static landing header + hero from index.html (painted before React loads).
export const StaticHero = ({ content }) => {
  const { user, config } = useAuth();
  const logo = config?.branding?.logo_url;
  const navigate = useNavigate();

  useEffect(() => {
    let el = document.getElementById("static-shell");
    const tpl = document.getElementById("static-shell-tpl");
    if (!el && tpl) { tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl); el = document.getElementById("static-shell"); }
    if (!el) return undefined;
    el.style.display = "";
    return () => { el.style.display = "none"; };
  }, []);

  useEffect(() => {
    [["ss-t", "landing_hero_title"], ["ss-h", "landing_hero_highlight"], ["ss-s", "landing_hero_subtitle"]].forEach(([id, k]) => {
      const n = document.getElementById(id);
      if (n && content[k]) n.textContent = content[k];
    });
  }, [content, user]);

  useEffect(() => {
    const img = $("[data-ss-logo-img]")[0], fallback = $("[data-ss-logo-fallback]")[0];
    if (!img || !fallback) return;
    const show = (on) => { img.classList.toggle("hidden", !on); fallback.classList.toggle("hidden", on); };
    if (!logo) { show(false); return; }
    img.onerror = () => show(false);
    img.src = assetUrl(logo);
    show(true);
  }, [logo]);

  useEffect(() => {
    $("[data-ss-link]").forEach((a) => { a.onclick = (e) => { e.preventDefault(); navigate(a.getAttribute("href")); }; });
    const dest = user?.onboarding_complete ? "/dashboard" : "/onboarding";
    $("[data-ss-signin]").forEach((b) => {
      b.onclick = user ? () => navigate(dest) : startGoogleLogin;
      b.querySelector("[data-ss-g]")?.classList.toggle("hidden", !!user);
      const full = b.querySelector("[data-ss-full]"), short = b.querySelector("[data-ss-short]");
      if (full) full.textContent = user ? "Go to my dashboard →" : "Sign In";
      if (short) short.textContent = user ? "Dashboard →" : "Sign In";
    });
  }, [user, navigate]);

  return null;
};
